import { render, staticRenderFns } from "./AddDocumentsApplicant.vue?vue&type=template&id=12686c9c&"
import script from "./AddDocumentsApplicant.vue?vue&type=script&lang=js&"
export * from "./AddDocumentsApplicant.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports